<template>
  <vs-card>
    <div slot="media" v-if="article.imageUrls.length > 0">
      <div class="overlay-container">
        <img
          v-if="showDetails"
          @click.stop.prevent
          v-img="{ group: article.articleId }"
          class="rounded-t-lg"
          :src="article.imageUrls[0]"
          :alt="article.title"
        />
        <img
          class="rounded-t-lg"
          v-else
          :src="article.imageUrls[0]"
          :alt="article.title"
        />
        <div v-if="showDetails && article.imageUrls.length > 1" class="bottom-right py-1 rounded-full px-3">
          1/{{ article.imageUrls.length }}
        </div>
      </div>
      <img
        v-for="(url, idx) in article.imageUrls"
        :key="idx"
        v-img="{ group: article.articleId }"
        :src="url"
        class="hidden"
      />
    </div>
    <div class="text-xm">
      {{ article.created | date }} •
      <feather-icon
        icon="HeartIcon"
        class="inline-block"
        svgClasses="h-3 w-3"
      />
      {{ article.numLikes }}
      •
      <feather-icon
        icon="MessageCircleIcon"
        class="inline-block"
        svgClasses="h-3 w-3"
      />
      {{ article.numComments }}
    </div>

    <h6>{{ article.title }}</h6>
    <div v-if="showDetails">
      <!--  <div class="text-xm">
        <a @click="showContent = !showContent" class="cursor-pointer">{{
          showContent ? "Show less" : "Show more"
        }}</a>
      </div> -->
      <div
        class="text-sm whitespace-pre-wrap news-content mt-2"
        v-if="article.content"
        v-html="article.content"
      ></div>
      <vs-divider />
      <div class="flex px-2 justify-between">
        <div
          @click="toggleLike"
          class="flex align-middle cursor-pointer"
          :style="{
            color: article.likedByMe
              ? 'rgba(var(--vs-success), 1)'
              : 'rgba(var(--vs-primary), 1)',
          }"
        >
          <feather-icon
            icon="HeartIcon"
            class="inline-block"
            svgClasses="h-6 w-6"
          />
          <span class="article-action ml-1">{{
            article.likedByMe ? "You like" : "Like"
          }}</span>
        </div>
        <div
          class="flex align-middle cursor-pointer"
          @click="showComments = !showComments"
          :style="{
            color: showComments
              ? 'rgba(var(--vs-success), 1)'
              : 'rgba(var(--vs-primary), 1)',
          }"
        >
          <feather-icon
            icon="MessageCircleIcon"
            class="inline-block"
            svgClasses="h-6 w-6"
          />
          <span class="article-action ml-1">Comments</span>
        </div>
      </div>
      <div v-if="showComments">
        <vs-divider />
        <h6 class="mb-2">Comments ({{ comments.length }})</h6>
        <div
          v-for="comment in comments"
          :key="comment.commentId"
          class="text-sm mb-2"
        >
          <span
            ><strong>{{ comment.authorName }}</strong></span
          >
          • <small>{{ comment.createdUtc | date }}</small>
          <p>{{ comment.content }}</p>
        </div>
        <vs-divider />
        <vs-input
          icon-after="true"
          label-placeholder="icon-after"
          class="w-full"
          icon="mode_edit"
          @keyup.enter="addComment"
          placeholder="New comment. Press enter to add"
          v-model="commentText"
        />
      </div>
    </div>
    <!--           <div class="iframe-container">
              <iframe frameborder="0" border="0" cellspacing="0" class="responsive-iframe" :srcdoc="article.content"></iframe></div> -->
  </vs-card>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { mapGetters } from "vuex";
import { format } from "timeago.js";
import router from "@/router";
export default {
  props: ["article", "showDetails"],
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return { showContent: false, showComments: false, commentText: "" };
  },
  async mounted() {},
  watch: {
    showDetails(newVal, oldVal) {
      if (newVal) {
        this.$store.dispatch("news/getComments", this.article.articleId);
      }
    },
  },
  computed: {
    ...mapGetters({
      comments: "news/comments",
    }),
  },
  methods: {
    async toggleLike() {
      this.article.likedByMe = !this.article.likedByMe;
      this.article.numLikes =
        this.article.numLikes + (this.article.likedByMe ? 1 : -1);
      await this.$store.dispatch("news/toggleLike", this.article.articleId);
    },
    async addComment() {
      const comment = this.commentText;
      this.commentText = "";
      await this.$store.dispatch("news/addComment", {
        articleId: this.article.articleId,
        content: comment,
      });
      await this.$store.dispatch("news/getComments", this.article.articleId);
    },
  },
};
</script>

<style>
.news-content img {
  max-width: 100%;
}
</style>



<style scoped>
.article-action {
  font-size: 1rem;
}
.overlay-container {
  position: relative;
  text-align: center;
  color: #333;
}
.bottom-right {
  background-color: white;
  position: absolute;
  bottom: 8px;
  right: 16px;
}
.iframe-container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%;
}

.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>

